import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { VNode } from 'vue'

@Component
export class BaseView<T> extends Vue {
  tableData: Array<T> = []
  tableLoading = false
  modalLoading = false
  modalVisible = false
  drawerVisible = false
  drawerLoading = false
}

@Component
export class BaseTable<T> extends Vue {
  @Prop()
  data: Array<T>

  @Prop()
  loading: boolean
  
}

@Component
export class BaseForm extends Vue {
  @Ref() readonly dForm: any

  schema = {
    properties: {},
    required: []
  }

  render(): VNode {
    return <d-form schema={this.schema} ref="dForm" />
  }
}